export interface ShortFeedEditor {
  id: number
  name: string
  surname?: string | null
  username?: string | null
  avatar?: string | null
  image?: string | null
}

export function formatEditorDisplayName(
  editor?: Pick<ShortFeedEditor, 'name' | 'surname'> | null,
): string | null {
  if (!editor?.name?.trim()) return null
  return [editor.name, editor.surname].filter(Boolean).join(' ').trim()
}

export function formatEditorHandle(
  editor?: Pick<ShortFeedEditor, 'username' | 'name'> | null,
): string | null {
  const username = editor?.username?.trim()
  if (username) return `@${username.toLowerCase()}`
  return null
}

/** Handle ile görünen ad aynıysa tekrar gösterme (YouTube kanalları vb.) */
export function formatEditorHandleDistinct(
  editor?: Pick<ShortFeedEditor, 'username' | 'name' | 'surname'> | null,
): string | null {
  const handle = formatEditorHandle(editor)
  if (!handle) return null
  const display = formatEditorDisplayName(editor)
  if (!display) return handle
  const normalizedHandle = handle.replace(/^@/, '').toLowerCase()
  if (normalizedHandle === display.toLowerCase()) return null
  return handle
}

export function getAuthorProfileHref(
  editor?: Pick<ShortFeedEditor, 'username' | 'id'> | null,
): string | null {
  if (!editor) return null
  const username = editor.username?.trim()
  if (username) return `/author/${username.toLowerCase()}`
  return null
}

export function getAuthorsIndexHref() {
  return '/authors'
}

export function getAuthorAvatarUrl(
  editor?: Pick<ShortFeedEditor, 'avatar' | 'image'> | { avatar?: string | null; image?: string | null; name?: string | null } | null,
): string | null {
  const raw = editor?.avatar?.trim() || editor?.image?.trim()
  return raw || null
}

export function getAuthorInitial(
  editor?: { name?: string | null; username?: string | null } | null,
): string {
  const fromName = editor?.name?.trim()?.charAt(0)
  if (fromName) return fromName.toUpperCase()
  const fromUser = editor?.username?.trim()?.charAt(0)
  if (fromUser) return fromUser.toUpperCase()
  return 'H'
}
